export default __webpack_public_path__ + "img/dtWpEluc.3704a600.svg";